import { tvApi } from "api";
import React from "react";
import TvPresenter from "./TvPresenter";

export default class extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            topRated: null,
            popular: null,
            airingToday: null,
            loading: true,
            error: null
        }
    }
    async componentDidMount(){
        try{
            const {data: {results: topRated}} = await tvApi.topRated();
            const {data: {results: popular}} = await tvApi.popular();
            const {data: {results: airingToday}} = await tvApi.airingToday();
            
            this.setState({
                topRated,
                popular,
                airingToday,
               
            })
        }catch(error){
            this.setState({
                error: "can't find movies information"}
            )
        }finally{
            setTimeout(() => {
                this.setState({
                    loading: false
    
                })
            }, 1500);
        }
    }

    render(){
        const{ topRated, popular, airingToday, error, loading} = this.state;
        console.log(this.state);
        return(
            <TvPresenter 
            topRated={topRated} 
            popular={popular} 
            airingToday={airingToday} 
            error={error} 
            loading={loading} />
        )
    }
}